import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import "../../styles/ConsultantEvaluation.css";
import PageLoder from '../../components/PageLoader';
import exportRenewalToPDF from '../../components/ExportRenewalPDF';
import LogoImage from '../../assets/logo_img.png';
export default function AdminRenewalList() {
     const [empCode, setEmpCode] = useState("");
     const [quarter, setQuarter] = useState("");
     const currentYear = new Date().getFullYear();
     const [year, setYear] = useState(currentYear.toString());
     const [renewals, setEvaluations] = useState([]);
     const [currentPage, setCurrentPage] = useState(1);
     const [pageSize, setPageSize] = useState(10);
     const [loading, setLoading] = useState(false);
     const [message, setMessage] = useState(null);
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [renewal, setRenewal] = useState(null);
     const [details, setDetails] = useState([]);
     const [selectedId, setSelectedId] = useState(null);

     const fetchEvaluations = async (code = "", q = "", y = currentYear.toString()) => {
          setMessage(null);
          setLoading(true);
          try {
               const token = localStorage.getItem("token");
               const headers = { Accept: "application/json" };
               if (token) headers["Authorization"] = `Bearer ${token}`;

               const params = new URLSearchParams();
               if (code && code.toString().trim() !== "") params.set('emp_code', code.toString().trim());
               if (q && q.toString().trim() !== "") params.set('quarter', q.toString().trim());
               if (y && y.toString().trim() !== "") params.set('year', y.toString().trim());

               const url = `${baseUrl}/getRenewalListByFilter?${params.toString()}`;
               const res = await fetch(url, { method: "GET", headers });
               const json = await res.json();
               if (res.ok) {
                    const list = Array.isArray(json) ? json : [];
                    // sort so submitted (is_submitted === 'Y') appear first
                    const sorted = list.slice().sort((a, b) => {
                         const aSub = (a && a.is_submitted) === 'Y';
                         const bSub = (b && b.is_submitted) === 'Y';
                         if (aSub === bSub) return 0;
                         return aSub ? -1 : 1;
                    });
                    setEvaluations(sorted);
                    setCurrentPage(1);
               } else {
                    setMessage({ type: "error", text: json.error || JSON.stringify(json) });
               }
          } catch (err) {
               console.error(err);
               setMessage({ type: "error", text: "Request failed" });
          } finally {
               setLoading(false);
          }
     };

     const navigate = useNavigate();

     const userRole = (sessionStorage.getItem('user_role') || localStorage.getItem('userRole') || '').toString().toUpperCase();
     const isAdminUser = userRole.includes('LAB_DIRECTOR') || userRole.includes('HR') || userRole === 'SUPER_ADMIN';



     const formatDateOnly = (s) => {
          if (!s) return '';
          try {
               let ds = String(s).trim();
               if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(ds)) ds = ds.replace(' ', 'T');
               const d = new Date(ds);
               if (!isNaN(d.getTime())) {
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    return `${dd}-${mm}-${yyyy}`;
               }
          } catch (e) { }
          return String(s).split('T')[0] || String(s);
     };

     const formatDateTime = (s) => {
          if (!s) return '';
          try {
               let ds = String(s).trim();
               if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(ds)) ds = ds.replace(' ', 'T');
               const d = new Date(ds);
               if (!isNaN(d.getTime())) {
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    const hh = String(d.getHours()).padStart(2, '0');
                    const min = String(d.getMinutes()).padStart(2, '0');
                    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
               }

          } catch (e) { }
          return String(s).split('T')[0] || String(s);
     };

     const getSubmittedDate = (ev) => {
          if (!ev) return '';
          const candidates = [
               'submitted_on', 'submittedOn', 'submitted_at', 'submittedAt', 'submitted_date', 'submittedDate',
               'updated_at', 'updatedAt', 'updated_on', 'updatedOn', 'updated_dtm', 'updatedDtm',
               'created_at', 'createdAt', 'created_on', 'createdOn', 'created_dtm', 'createdDtm'
          ];
          for (const k of candidates) {
               const v = ev[k];
               if (v === undefined || v === null) continue;
               const s = String(v).trim();
               if (!s) continue;
               // ignore zero dates
               if (/^0{2,4}[-:\s0]+$/.test(s)) continue;
               if (s === '0000-00-00' || s === '0000-00-00 00:00:00') continue;
               return s;
          }
          return '';
     };

     const handleDelete = async (id) => {
          if (!window.confirm('Delete this evaluation? ')) return;
          setLoading(true);
          try {
               const token = localStorage.getItem('token');
               const headers = { Accept: 'application/json' };
               if (token) headers['Authorization'] = `Bearer ${token}`;

               const url = `${baseUrl}/deleteConsultantEvaluation/${id}`;
               const res = await fetch(url, { method: 'DELETE', headers });
               const json = await res.json();
               if (res.ok) {
                    // remove from state
                    setEvaluations(prev => prev.filter(ev => ev.id !== id));
                    setMessage({ type: 'success', text: json.message || 'Deleted' });
               } else {
                    setMessage({ type: 'error', text: json.error || JSON.stringify(json) });
               }
          } catch (err) {
               console.error(err);
               setMessage({ type: 'error', text: 'Delete request failed' });
          } finally {
               setLoading(false);
          }
     };

     const handleSearch = (e) => {
          e && e.preventDefault();
          fetchEvaluations(empCode, quarter, year);
     };

     useEffect(() => {
          // fetch renewals for current year on load (no emp_code)
          fetchEvaluations("", "", currentYear.toString());
     }, []);

     // trigger search when filters change (debounced)
     useEffect(() => {
          const t = setTimeout(() => {
               fetchEvaluations(empCode, quarter, year);
          }, 350);
          return () => clearTimeout(t);
     }, [empCode, quarter, year]);

     const totalPages = Math.max(1, Math.ceil(renewals.length / pageSize));

     useEffect(() => {
          if (currentPage > totalPages) setCurrentPage(totalPages);
     }, [renewals, pageSize, totalPages]);

     const startIndex = (currentPage - 1) * pageSize;
     const endIndex = Math.min(startIndex + pageSize, renewals.length);
     const pagedEvaluations = renewals.slice(startIndex, endIndex);

     const exportRenewalCSV = (filename = `consultant_renewals_${year || 'all'}.csv`) => {
          if (!renewals || renewals.length === 0) {
               setMessage({ type: 'error', text: 'No data to export' });
               return;
          }
          const headers = ['Emp Code', 'Name', 'Year', 'Branch', 'Total Points', 'Submitted', 'Submitted On'];
          const rows = renewals.map(ev => [
               ev.emp_code || '',
               ev.emp_name || ev.comp_name || '',

               ev.year || '',
               ev.centre || '',
               ev.total_points != null ? ev.total_points : '',
               ev.is_submitted === 'Y' ? 'Yes' : 'No',
               // ev.submitted_on
               ev.is_submitted === 'Y' ? (formatDateTime(getSubmittedDate(ev)) || 'Unknown') : ''
          ]);

          const escapeCell = (cell) => {
               if (cell === null || cell === undefined) return '';
               const s = cell.toString();
               // escape double quotes
               return `"${s.replace(/"/g, '""')}"`;
          };

          const csvContent = [headers, ...rows].map(r => r.map(escapeCell).join(',')).join('\r\n');

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
     };


     const downloadPDF = async (selectedRecord) => {
          if (!selectedRecord?.id) {
               setMessage({
                    type: 'error',
                    text: 'Invalid renewal record'
               });
               return;
          }

          try {
               const token = localStorage.getItem('token');

               const headers = {
                    Accept: 'application/json'
               };

               if (token) {
                    headers.Authorization = `Bearer ${token}`;
               }

               /*
                * 1. Fetch the complete renewal record
                */
               const renewalUrl = `${baseUrl.replace(/\/$/, '')}/getConsultantRenewal/${selectedRecord.id}`;

               const renewalRes = await fetch(renewalUrl, {
                    method: 'GET',
                    headers
               });

               if (!renewalRes.ok) {
                    throw new Error(
                         `Failed to fetch renewal: ${renewalRes.status}`
                    );
               }

               const renewalJson = await renewalRes.json();

               /*
                * 2. Extract renewal and details
                */
               let renewalData = null;
               let detailsData = [];

               if (renewalJson && renewalJson.renewal) {
                    renewalData = renewalJson.renewal;

                    detailsData = Array.isArray(renewalJson.details)
                         ? renewalJson.details
                         : [];
               } else if (
                    Array.isArray(renewalJson) &&
                    renewalJson.length > 0
               ) {
                    renewalData = renewalJson[0];

                    detailsData = Array.isArray(renewalJson[0].details)
                         ? renewalJson[0].details
                         : [];
               } else if (
                    renewalJson &&
                    typeof renewalJson === 'object'
               ) {
                    renewalData = renewalJson;

                    detailsData = Array.isArray(renewalJson.details)
                         ? renewalJson.details
                         : [];
               }

               if (!renewalData) {
                    throw new Error('Renewal record not found');
               }

               /*
                * 3. Fetch question bank
                *
                * This is the important part.
                * The question text is merged into each detail record.
                */
               const questionsUrl =
                    `${baseUrl.replace(/\/$/, '')}/getConsultantRenewalQuestions`;

               const questionsRes = await fetch(questionsUrl, {
                    method: 'GET',
                    headers
               });

               if (questionsRes.ok) {
                    const questionsJson = await questionsRes.json();

                    if (Array.isArray(questionsJson)) {
                         const questionMap = questionsJson.reduce(
                              (acc, question) => {
                                   acc[String(question.id)] =
                                        question.question_text ||
                                        question.question ||
                                        '';

                                   return acc;
                              },
                              {}
                         );

                         /*
                          * Merge question_text into the details.
                          */
                         detailsData = detailsData.map(detail => ({
                              ...detail,

                              question_text:
                                   detail.question_text ||
                                   questionMap[String(detail.question_id)] ||
                                   questionMap[String(detail.id)] ||
                                   ''
                         }));
                    }
               }

               console.log('PDF Renewal:', renewalData);
               console.log('PDF Details:', detailsData);

               /*
                * 4. Export PDF with the enriched details
                */
               await exportRenewalToPDF({
                    renewal: renewalData,
                    details: detailsData,
                    id: selectedRecord.id,
                    baseUrl,
                    publicUrl: process.env.PUBLIC_URL || '',
                    logoImage: LogoImage,
                    envFileUrl: process.env.REACT_APP_FILE_URL || ''
               });

          } catch (e) {
               console.error('Export failed:', e);

               setMessage({
                    type: 'error',
                    text: 'Export failed'
               });
          }
     };
     return (
          <div className="consultant-eval">
               <div className="row" >
                    <div className="col-sm-3">
                         <h2>Consultant Renewals</h2>

                    </div>
                    <div className="col-sm-6" >
                         <form onSubmit={handleSearch} className="search-row" style={{ marginBottom: 12 }}>
                              <label >
                                   <span style={{ paddingLeft: 10 }}>  Employee Code</span>
                                   <input value={empCode} onChange={(e) => setEmpCode(e.target.value)} style={{ marginLeft: 8 }} />
                              </label>

                              <label>
                                   <span style={{ paddingLeft: 10 }}> Year</span>
                                   <select value={year} onChange={(e) => setYear(e.target.value)} style={{ marginLeft: 8 }}>
                                        <option value={currentYear.toString()}>{currentYear}</option>
                                        {/* <option value={(currentYear - 1).toString()}>{currentYear - 1}</option> */}
                                        <option value="">Any</option>
                                   </select>
                              </label>
                              {/* Search is triggered automatically when filters change */}
                              <label style={{ marginLeft: 8 }}>
                                   <span style={{ paddingLeft: 10 }}>  Page size</span>
                                   <select value={pageSize} onChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setCurrentPage(1); }} style={{ marginLeft: 8 }}>
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                   </select>
                              </label>
                              <span style={{ marginLeft: 8, marginTop: 4, maxWidth: 8 }}>
                                   <button type="button" className="btn btn-sm" onClick={() => {
                                        setEmpCode('');

                                        setYear(currentYear.toString());
                                        setPageSize(10);
                                        setCurrentPage(1);
                                        fetchEvaluations('', '', currentYear.toString());
                                   }} style={{ marginLeft: 8 }}>Reset </button>
                              </span>

                         </form>
                    </div>
                    <div className="col-sm-3" style={{ textAlign: "right" }}>
                         <button className="btn" onClick={() => exportRenewalCSV()} style={{ marginRight: 8 }}>Export CSV</button>
                    </div>
               </div>
               <div>
                    {loading ? (
                         <div className="text-center py-4"><PageLoder /></div>
                    ) : renewals.length === 0 ? (
                         <div>No renewals to show.</div>
                    ) : (
                         <>
                              <table className="eval-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                                   <thead>
                                        <tr>
                                             <th>Sr. No</th>
                                             <th>Emp Code</th>
                                             <th>Name</th>
                                             <th>Year</th>
                                             <th>Centre</th>
                                             <th>Total Points</th>
                                             <th>Submitted</th>
                                             <th>Submitted On</th>
                                             <th>Actions</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {pagedEvaluations.map((ev, idx) => (
                                             <tr key={ev.id || startIndex + idx} style={ev.is_submitted === 'Y' ? {} : { backgroundColor: '#f7f7f7' }}>
                                                  <td>{startIndex + idx + 1}</td>
                                                  <td>{ev.emp_code}</td>
                                                  <td>{ev.emp_name || ev.comp_name || ""}</td>

                                                  <td>{ev.year}</td>
                                                  <td>{ev.centre}</td>
                                                  <td>{ev.total_points}</td>
                                                  <td>{ev.is_submitted === 'Y' ? 'Yes' : 'Renewal Drafted'}</td>
                                                  <td>{ev.is_submitted === 'Y' ? (formatDateTime(getSubmittedDate(ev)) || 'Unknown') : ''}</td>
                                                  <td className="action-btns">
                                                       <button type="button" className="icon-btn" title="Admin View" onClick={() => navigate(`/admin-renewals/${ev.id}`)}>
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                 <path d="M12 5C7 5 2.7 8.11 1 12c1.7 3.89 6 7 11 7s9.3-3.11 11-7c-1.7-3.89-6-7-11-7z" stroke="#222" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                 <circle cx="12" cy="12" r="3" stroke="#222" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                       </button>
                                                       {ev.is_submitted === 'Y' && isAdminUser && (
                                                            <button type="button" className="icon-btn" title="Edit" onClick={() => navigate(`/admin-renewals/${ev.id}/edit`)}>
                                                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                      <path d="M3 21v-3.6l11-11L20.6 9 9.6 20H3z" stroke="#0a66ff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                      <path d="M14 6l4 4" stroke="#0a66ff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                 </svg>
                                                            </button>
                                                       )}
                                                       {/* pdf download button required */}
                                                       {ev.is_submitted === 'Y' && (
                                                            <button
                                                                 type="button"
                                                                 className="icon-btn"
                                                                 title="Download PDF"
                                                                 onClick={() => downloadPDF(ev)}
                                                            >
                                                                 <svg
                                                                      width="16"
                                                                      height="16"
                                                                      viewBox="0 0 24 24"
                                                                      fill="none"
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                 >
                                                                      <path
                                                                           d="M12 3v12m0 0 4-4m-4 4-4-4M5 21h14"
                                                                           stroke="#222"
                                                                           strokeWidth="1.5"
                                                                           strokeLinecap="round"
                                                                           strokeLinejoin="round"
                                                                      />
                                                                 </svg>
                                                            </button>
                                                       )}
                                                  </td>
                                             </tr>
                                        ))}
                                   </tbody>
                              </table>

                              <div className="pagination">
                                   <div className="page-info">Showing {Math.min((currentPage - 1) * pageSize + 1, renewals.length)} - {Math.min(currentPage * pageSize, renewals.length)} of {renewals.length}</div>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>First</button>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>Prev</button>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>Next</button>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>Last</button>
                              </div>
                         </>
                    )}
               </div>
          </div>
     );
}
